import React from 'react';
import { graphql } from 'gatsby';
import queryString from 'query-string';
import useCookie from 'react-use-cookie';

import ContactForm from '../components/ContactForm';
import Heading from '../components/renderers/Heading';
import Hero from '../components/Hero';
import MarkdownRenderer from '../components/MarkdownRenderer';
import RelatedContent from '../components/RelatedContent';
import Section from '../components/Section';
import SectionHero from '../components/SectionHero';
import Stats from '../components/renderers/Stats';

const ContactBaseTemplate = ({
  data: { relatedContent },
  location,
  pageContext: { page },
}) => {
  const params = queryString.parse(location.search);
  const [referrer] = useCookie('referrer', 'Direct');

  return (
    <React.Fragment>
      <Section size="small">
        <Hero {...page} />
      </Section>
      <Section size="small">
        <div className="md:flex md:-mx-6">
          <div className="md:px-6 md:w-1/2 lg:w-3/5">
            <MarkdownRenderer {...page} />
          </div>
          <div className="md:px-6 md:w-1/2 lg:w-2/5 my-12">
            <div className="md:sticky md:top-0">
              <div className="md:-mt-12 mb-4">
                <Heading level={4}>Talk to an expert</Heading>
                <hr className="inline-block bg-cornflower border-0 h-1 rounded w-24 md:w-48" />
              </div>
              <ContactForm {...params} referrer={referrer} />
            </div>
          </div>
        </div>
      </Section>
      <Section container="narrow" size="small">
        <SectionHero noHr title="Why GraphCMS?" />

        <Stats
          children={{
            '∞': 'Locales, users and entries on Enterprise plans',
            '24/7': 'Up to 24/7 support',
            '99.9%': 'Up to 99.9% uptime SLA*',
          }}
        />
      </Section>

      <RelatedContent relatedContent={relatedContent.nodes} />
    </React.Fragment>
  );
};

export const query = graphql`
  query contactPageQuery {
    relatedContent: allGraphCmsCaseStudy(limit: 2) {
      nodes {
        id
        slug
        friendlySlug
        title
        subTitle
        coverImage {
          id
          url
          handle
          width
          height
        }
        excerpt
        hasContent
        content
        externalUrl
        company {
          name
          url
          logo {
            id
            url
            handle
            width
            height
          }
        }
        linkPath
      }
    }
  }
`;

export default ContactBaseTemplate;
